/* tslint:disable */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationInterface } from './api-configuration';

import { InformationFieldsControllerService } from './services/information-fields-controller.service';
import { UploadRequestControllerService } from './services/upload-request-controller.service';
import { RequestControllerService } from './services/request-controller.service';
import { TemplateControllerService } from './services/template-controller.service';
import { UploadRequestUploadControllerService } from './services/upload-request-upload-controller.service';
import {MatInputModule} from "@angular/material";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatIconModule} from "@angular/material/icon";
import {MatNativeDateModule} from "@angular/material/core";

/**
 * Provider for all Api services, plus ApiConfiguration
 */
@NgModule({
  imports: [
    HttpClientModule,MatInputModule,
    MatFormFieldModule,MatFormFieldModule,
    MatInputModule, MatDatepickerModule,MatIconModule,
    MatNativeDateModule
  ],
  exports: [
    HttpClientModule,MatInputModule,MatFormFieldModule
  ],
  declarations: [],
  providers: [
    ApiConfiguration,
    InformationFieldsControllerService,
    UploadRequestControllerService,
    RequestControllerService,
    TemplateControllerService,
    UploadRequestUploadControllerService,
  ]
})
export class ApiModule {
  static forRoot(customParams: ApiConfigurationInterface): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: {rootUrl: customParams.rootUrl}
        }
      ]
    }
  }
}
